<div class="modal-header xxl-modal">
  <h5 class="modal-title">Select from Database</h5>
  <button type="button" class="close" style="border: none; background-color: transparent; font-size: 1.75em;" data-dismiss="modal" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form (submit)="loadPCDBData()">
    <div class="row">
      <div class="col-md-6">
        <app-custom-input-type
          formElementId="heating-pcdb-category"
          [canEdit]="true"
          [inputTypeConfiguration]="{
            typeId: inputTypeDefinitions.DROP_DOWN,
            required: true,
            includeLabel: true,
            labelText: 'Brand Name',
            options: brandNameOptions,
            initialValue: ''
          }"
          (updateValue)="brandChanged($event, true)"
          >
        </app-custom-input-type>
      </div>

      <div class="col-md-6">
        <app-custom-input-type formElementId="heating-pcdb-fuel" [canEdit]="true"
          [ngClass]="{ formClasses: 'layout-column', labelClasses: 'font-16' }" [inputTypeConfiguration]="{
            typeId: inputTypeDefinitions.DROP_DOWN,
            required: false,
            includeLabel: true,
            labelText: 'Model Name',
            options: modelNameOptions,
            initialValue: ''
          }" (updateValue)="modelChanged($event)">
        </app-custom-input-type>
      </div>
      <div class="col-md-11 mt-2">
        <app-custom-input-type form-element-id="heating-pcdb-searchTerms" [ngClass]="{
            formClasses: 'layout-column flex-grow-1',
            labelClasses: 'font-16'
          }" [canEdit]="true" [inputTypeConfiguration]="{
            typeId: inputTypeDefinitions.FREE_TEXT,
            required: true,
            includePlaceholderText: true,
            placeholderText: 'Enter search terms separated by spaces',
            initialValue: searchData
          }" (updateValue)="searchDataChanged($event)">
        </app-custom-input-type>
      </div>
      <div class="col-md-1">
        <button type="submit" class="btn btn-primary ml-2 mt-2" aria-label="Search">
          <i class="bi bi-search fs-6"></i>
        </button>
      </div>
    </div>
  </form>
  <div class="row pt-15">
    <div *ngIf="searchData && !pcdbSearchResults.length && searchData === searchDataBackup && !isLoading"
      class="text-center" style="color: red">
      No results matching "{{ searchData }}".
    </div>
    <div class="table-responsive">
      <table *ngIf="pcdbSearchResults.length && !isLoading" class="table table-responsive table-striped table-hover"
        ms-responsive-table dt-options="dtOptions">
        <thead>
          <tr>
            <th></th>
            <th>Index</th>
            <th>Manufacturer</th>
            <th>Model</th>
            <th>Qualifier</th>
            <th>GC No.</th>
            <th>Flue Type</th>
            <!-- <th>Fan Assisted</th>
            <th>Winter Efficiency</th>
            <th>Summer Efficiency</th>
            <th>First Year</th>
            <th>Final Year</th> -->
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of getPaginatedResults()" style="cursor: pointer" (click)="setSelectedPcdbData(data)">
            <td>
              <i *ngIf="data === selectedPcdbData" class="bi bi-check-circle text-success"></i>
            </td>
            <td>{{ data.id }}</td>
            <td>{{ data.brandName }}</td>
            <td>{{ data.modelName }}</td>
            <td>{{ data.modelQualifier }}</td>
            <td>{{ data.boilerId }}</td>
            <td>{{ getFlueTypeDisplay(data.flueType) }}</td>
            <td>
              <button 
                class="btn btn-warning" 
                (click)="openPcdbRecord(data); $event.stopPropagation();">
                Details
              </button>
            </td>
            <!-- <td>{{ [data.fanAssisted] }}</td>
            <td>{{  data.winterEfficiency }}</td>
            <td>{{ data.summerEfficiency }}</td>
            <td>{{  data.firstYear }}</td>
            <td>{{ data.finalYear }}</td> -->
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination-controls">
      <button class="btn btn-primary" (click)="previousPage()" [disabled]="currentPage === 1">
        Previous
      </button>

      <div class="page-number-container">
        <div>{{ currentPage }} / {{ totalPages }}</div>
      </div>

      <button class="btn btn-primary" (click)="nextPage()" [disabled]="currentPage === totalPages">
        Next
      </button>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="cancel()">
    Cancel
  </button>
  <button type="button" class="btn btn-primary" (click)="commitAndCloseModal()" [disabled]="!selectedPcdbData">
    Select
  </button>
</div>
